@if (events$ | async; as events) {
  @if (events.length > 0) {
    <div class="container px-0 events-wrapper">
      <!-- Header with matched gutters -->
      <div class="row g-4 g-lg-5 align-items-center mb-5">
        <div class="col">
          <h2 class="m-0">{{ block.data.title ?? 'Upcoming Events' }}</h2>
        </div>
        <div class="col-auto">
          @if (block.data.buttonText) {
            <a class="coro-btn coro-btn--solid coro-btn--regular" [routerLink]="block.data.buttonURL">
              {{ block.data.buttonText }}
            </a>
          }
        </div>
      </div>
      <div class="row g-4 g-lg-5">
        @for (event of events; track event) {
          <div class="col-12 col-xl-4">
            <div
              class="event-item"
              tabindex="0"
              (click)="handleEvent('Clicked', event)"
              (keydown.enter)="handleEvent('Keyboard Enter', event)"
              (keydown.space)="handleEvent('Keyboard Space', event)">
              <div class="event-item__date">
                <p class="event-item__date--month" [innerText]="getLocalizedMonth(event.start)"></p>
                <p class="event-item__date--day" [innerText]="event.start | date: 'd'"></p>
                <p class="event-item__time--start" [innerText]="event.start | date: 'h:mm a'"></p>
              </div>
              <div class="event-item__desc">
                <p class="event-item__desc--name" [innerText]="event.title | translate"></p>
                <p class="event-item__desc--desc" [innerHTML]="event.description ?? '' | limitTo: 100"></p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
}

<!-- Event Modal -->
<ng-template #eventModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ modalData?.event?.title || '' | translate }}
    </h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeEventModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex">
      <div>
        <div class="d-flex">
          <span
            [ngStyle]="{
              'background-color': 'var(--color-calendar-view-btn-hover)',
              'margin-top': '7px',
            }"
            class="badge-dot"></span>
          <div class="ms-2">
            <div class="text-muted mb-3">
              <strong>Date: </strong>
              <span [innerText]="modalData?.event?.start | date: 'fullDate'"></span>
              <br />
              <strong>Time: </strong>
              @if (modalData?.event?.allDay) {
                <span>{{ 'All Day' | translate }}</span>
              }
              @if (!modalData?.event?.allDay) {
                <span>
                  {{ modalData?.event?.start | date: 'shortTime' }}
                  @if (modalData?.event?.end) {
                    <span> - {{ modalData?.event?.end | date: 'shortTime' }} </span>
                  }
                </span>
              }
            </div>
            <div [innerHtml]="modalData?.event?.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
